var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { MODAL_TRANSITION_DURATION, } from '@connectrn/ds-ui-base';
import { CFDivider } from '../../components';
import { commonAttrs } from '../../utils';
import { CFModalBottomSheetElements } from './ModalBottomSheet.styles';
export const CFModalBottomSheetCore = (_a, ref) => {
    var { alternateTheme, children, footer, footerSafeGap, header, headerSafeGap, heightPreset = 'auto', id, onChangeLockPosition, onClose, onHide, onOpen, startOpen = false, variant = 'default', withDividers } = _a, rest = __rest(_a, ["alternateTheme", "children", "footer", "footerSafeGap", "header", "headerSafeGap", "heightPreset", "id", "onChangeLockPosition", "onClose", "onHide", "onOpen", "startOpen", "variant", "withDividers"]);
    const { Body, Footer, Header, Root, Sheet } = CFModalBottomSheetElements;
    const [active, setActive] = useState(startOpen);
    const [internalBody, setBody] = useState(children);
    const [internalFooter, setFooter] = useState(footer);
    const [internalHeader, setHeader] = useState(header);
    const rootProps = Object.assign({ footerSafeGap,
        headerSafeGap,
        heightPreset,
        variant }, commonAttrs(rest));
    const sheetProps = {
        alternateTheme,
        footerSafeGap,
        heightPreset,
        variant,
    };
    const close = (closeOptions) => {
        setActive(false);
        if (onClose)
            onClose(id);
        if (!closeOptions)
            return;
        const { onHide } = closeOptions;
        if (onHide) {
            setTimeout(() => {
                onHide(id);
            }, MODAL_TRANSITION_DURATION);
        }
    };
    const open = () => {
        setActive(true);
        if (onOpen)
            onOpen(id);
    };
    useImperativeHandle(ref, () => {
        return {
            close,
            id,
            open,
            setBody,
            setFooter,
            setHeader,
        };
    });
    return (React.createElement(CSSTransition, { in: active, timeout: MODAL_TRANSITION_DURATION }, (state) => (React.createElement(Root, Object.assign({ transitionState: state }, rootProps),
        React.createElement(Sheet, Object.assign({}, sheetProps),
            internalHeader && React.createElement(Header, null, internalHeader),
            internalHeader && withDividers && (React.createElement(CFDivider, { alternateTheme: alternateTheme, size: 'thin', fillGaps: 'd' })),
            internalBody && React.createElement(Body, null, internalBody),
            internalFooter && withDividers && (React.createElement(CFDivider, { alternateTheme: alternateTheme, size: 'thin', fillGaps: 'd' })),
            internalFooter && React.createElement(Footer, null, internalFooter))))));
};
export const CFModalBottomSheet = forwardRef(CFModalBottomSheetCore);
